import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

function Courses() {
  const courses = [
    {
      title: 'Рисунок для детей от 4 до 14 лет',
      description: 'Курс проходит онлайн и оффлайн. Наша задача — не учить академическому рисунку, а познакомить с основными понятиями, пробудить у детей интерес к творчеству и поднять их уверенность в себе.',
    },
    {
      title: 'Рисунок для взрослых',
      description: 'Наш курс создан для тех, кто всегда хотел научиться рисовать, но не знал, с чего начать, или для тех, кто хочет восстановить и развить уже имеющиеся навыки. Мы помогаем раскрыть творческий потенциал, освоить техники академического и современного рисунка, научиться видеть и передавать форму, свет и тень. Атмосфера занятий — это поддержка и вдохновение, без давления и страха ошибок.',
    },
    {
      title: 'POP-UP',
      description: 'Курс POP-UP — это увлекательное знакомство с объёмными иллюстрациями и искусством создания книг-трансформеров. Вы научитесь работать с бумагой и простыми механизмами, которые превращают рисунки в динамичные трёхмерные композиции. Такой курс развивает пространственное мышление, воображение и умение работать руками. Отлично подходит как для детей, так и для взрослых, которые любят эксперименты и нестандартные формы творчества.',
    },
    {
      title: 'Обучение начальной архитектуре',
      description: 'Курс знакомит с основами архитектурного мышления и проектирования. Мы учим видеть пространство, работать с пропорциями, создавать простые модели зданий и интерьеров. Занятия включают рисование, макетирование и обсуждение известных архитектурных решений. Это отличная база для тех, кто интересуется архитектурой и дизайном, хочет попробовать себя в профессии или развить навык пространственного восприятия.',
    },
  ];

  return (
    <Container className="mt-4">
      <h1>Наши курсы</h1>
      <p>
        Мы предлагаем разнообразные программы для всех возрастов и уровней подготовки.
        Выберите интересующее вас направление и начните творить вместе с нами!
      </p>

      <Row className="mt-4">
        {courses.map((course, index) => (
          <Col key={index} md={6} lg={4} className="mb-4">
            <Card>
              <Card.Body>
                <Card.Title>{course.title}</Card.Title>
                <Card.Text>{course.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Courses;
